import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=cb58ef54&scoped=true"
import script from "./myPage.vue?vue&type=script&lang=js"
export * from "./myPage.vue?vue&type=script&lang=js"
import style0 from "./myPage.vue?vue&type=style&index=0&id=cb58ef54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb58ef54",
  null
  
)

export default component.exports